var exports = {
  "t": "x936d19a0--61767a--submit",
};

module.exports = exports;
